module.exports = __webpack_public_path__ + "img/game1.2e94c3f6.jpg";